import { utils, writeFile } from "xlsx";

export const exportToXLSX = (data: any[], columns: any, filename: string) => {
  // Creamos un nuevo arreglo con los datos mapeados utilizando los nombres personalizados de las columnas
  const mappedData = data.map((item) => {
    const mappedItem: Record<string, unknown> = {};
    Object.keys(columns).forEach((key) => {
      const columnKey = key as keyof any;
      if (columns[columnKey]) {
        mappedItem[columns[columnKey]] = item[columnKey];
      }
    });
    return mappedItem;
  });

  const worksheet = utils.json_to_sheet(mappedData);

  // Personalizar los nombres de las columnas en el encabezado de la hoja de cálculo
  if (!worksheet["!cols"]) {
    worksheet["!cols"] = [];
  }

  Object.keys(columns).forEach((key, index) => {
    const columnKey = key as keyof any;
    worksheet["!cols"]?.push({ wch: columns[columnKey].length });
    worksheet[utils.encode_cell({ r: 0, c: index })] = {
      t: "s",
      v: columns[columnKey],
    };
  });

  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, "Sheet1");
  writeFile(workbook, filename);
};
